module.exports = __webpack_public_path__ + "static/media/lightning-icon.2103937a.jpg";